import React from "react";
import { imgArr } from "../../assets/images";

const TopComponent = () => {
  return (
    <>
      <div className="hero wapper">
        <div
          className="hero-content"
          data-aos="slide-right"
          data-aos-duration="1000"
          data-aos-delay="300"
        >
          <h1>For Plans that WORKOUT</h1>
          <p>
            Meet Circuit, a social fitness app built for connection and
            community. Coordinate classes with friends, discover new workouts
            through your network, and post about your experience. Transform your
            fitness routine into your personalized third space
          </p>

          <div className="mt-3">
            <a
              href="https://apps.apple.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={imgArr.appStore}
                alt="Download on the App Store"
                style={{ height: "40px", marginRight: "10px" }}
              />
            </a>
            <a
              href="https://play.google.com/store"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={imgArr.playStore}
                alt="Get it on Google Play"
                style={{ height: "40px" }}
              />
            </a>
          </div>
        </div>
        <div
          className="hero-image"
          data-aos="slide-left"
          data-aos-duration="1000"
          data-aos-delay="300"
        >
          <img
            src={imgArr.phoneHand}
            alt="Phone Map View"
            className="phone phone2"
          />
        </div>
        {/* Wave effect */}
        <div className="wave-effect">
          <div className="waves-shape shape-one">
            <div className="wave wave-one"></div>
          </div>

          <div className="waves-shape shape-two">
            <div className="wave wave-two"></div>
          </div>

          <div className="waves-shape shape-three">
            <div className="wave wave-three"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopComponent;
